export const locale_ca_ES = {
  //general
  tancar: 'Tanca',
  delete: 'Elimina',
  altCloseIcon: 'Icona tancar',
  localFileName: 'Arxiu local',
  coordinates: 'Coordenades',
  scale: 'Escala',
  value: 'Valor',

  //index
  error_obtainFeatures: 'Error al obtenir els elements de les capes seleccionades.',
  error_obtainPointInfo: 'Error al obtenir la informació de punt.',
  error_obtainLocation: 'El visor no té permís per accedir a la seva ubicació.',
  error_popUpsBlocked: 'El visor no té permís per obrir finestres emergents al navegador.',
  error_cercaElement: "No s'ha pogut obtenir informació d'aquest element.",
  error_noFeatures: 'No hi ha cap element amb el criteri seleccionat',
  //Modal info
  title1: 'Capes del catàleg',
  modalEx1: 'Ex.: Trames urbanes',
  modalEx2: 'Ex.: C-25',
  popUpSolR:
    "En la cerca avançada d'elements de capes hi ha una explicació dels modificadors que es poden utilitzar per afegir precisió o flexibilitat en aquest tipus de cerca.",
  modalEx3: 'Ex.: Passeig de Gràcia, 74, Barcelona',
  modalEx4: 'Ex.: C-25, 143',
  modalEx5: 'Ex.: 438300, 4642360',
  modalEx6: 'Ex.: 41.92894, 2.254689',

  //Modal PDF
  pdfTitle: 'Genera el PDF',
  pdfMapTitle: 'Títol del mapa: ',
  pdfLlegenda: 'Inclou la llegenda',
  pdfGenerar: 'Genera',
  pdfObrir: 'Obre',
  pdfDownload: 'Descarrega',
  pdfError: 'Error en la creació del document',
  mapNamePH: 'Introdueix nom del mapa...',

  //compartir
  fileName: "Nom de l'arxiu",
  shareSocialTitle: 'Envia l’enllaç de la visualització actual per:',
  userSpace: 'ESPAI USUARI',
  hardDrive: 'DISC DUR',
  loadFile: 'Carrega un mapa',
  loadMap: 'Carrega fitxer local',
  myMaps: 'Els meus mapes',
  local: 'Fitxer local',
  gestion: 'Gestiona mapes',
  saveCat: 'Desa el mapa actual',
  saveCatLocal: 'Descarrega el mapa actual',
  desa: 'Desa el mapa',
  desaLocal: 'Descarrega fitxer local',
  defaultMaps: 'Mapes predefinits',
  filterMaps: 'Cerca mapes...',
  noResultsMap: "No s'han trobat resultats.",
  fileNamePH: "Escriu el nom de l'arxiu...",
  replaceMap1: 'El mapa ',
  replaceMap2: ' ja existeix. El vols reemplaçar pel mapa actual?',
  replaceTitle: 'Confirma reemplaçar mapa',
  deleteTitle: 'Confirma eliminar mapa',
  deleteMap: 'Segur que vols eliminar el mapa amb nom: ',
  replaceAccept: 'Reemplaça',
  replaceTooltip: 'Reemplaça mapa',
  deleteMapTooltip: 'Esborra mapa',
  replaceFast1: 'Vols reemplaçar el mapa ',
  replaceFast2: ' pel mapa actual?',
  defaultMapsTitle: 'Obre un dels mapes predefinits de la plataforma',
  userMapsTitle: 'Obre, elimina o reemplaça un dels teus mapes',
  titleNoUser: 'Descarrega/carrega mapa',

  //llegenda
  aria_llegendaBtn: 'obrir llegenda',
  llegendaHide: 'Amaga totes les capes',
  llegendaShow: 'Mostra totes les capes',
  obrirLlegenda: 'Llegenda',
  GMLText: 'GML',
  KMLText: 'KML',
  SHPText: 'ShapeFile',
  CSVText: 'CSV',
  TIFText: 'GeoTIFF',
  titleStyles: 'Simbologies disponibles',
  titleExport: 'Formats de descarrega disponibles',
  titleTransparency: 'Opacitat',
  selecciona: 'SELECCIONA',
  netejaLlegenda: 'Neteja la llegenda',
  expandLlegenda: 'Expandeix elements de la llegenda',
  contractLlegenda: 'Contrau elements de la llegenda',
  showLayer: 'Mostra/amaga capa',
  transparency: 'Transparència de la capa',
  showInfo: 'Activa/desactiva la informació de la capa',
  metadata: 'Metadada de la capa',
  stylesSelect: 'Simbologia de la capa',
  export: 'Descarrega la capa',
  closeLayer: 'Tanca la capa',
  layerFilter: 'Filtra la capa',
  layerStats: 'Estadístiques de la capa',
  layerZoom: 'Zoom a la capa',
  field: 'Camp',
  kmlAlert: "Atenció! Modificar l'estil d'un fitxer KML substituirà per complert la representació inicial.",
  styleSymbol: 'Simbologia',

  //Edició
  edit: 'Edita elements de capa',
  newEle: 'Crea nou element',
  edition: "Edició d'element",
  save: 'Guarda',
  cancel: 'Cancela',

  //toasts
  iframeSuccess: "El codi s'ha copiat al porta-retalls.",
  deleteGeomError: "L'element només té una geometria.",
  clipboardError: "S'ha produit un error al copiar al porta-retalls.",
  urlSuccess: "L'enllaç s'ha copiat al porta-retalls.",
  errorPK: "No s'ha pogut obtenir el punt quilomètric.",
  errorAddress: "No s'ha pogut obtenir l'adreça.",
  errorElements: "No s'han pogut obtenir els elements.",
  errorLayerDownload:
    "No es permet la descàrrega completa d'aquesta capa. Seleccioneu el conjunt de registres a descarregar des del filtre de la capa ",
  errorLayerExport: "S'ha produit un error a l'exportar la capa",
  errorLayerExportSize: 'El número d’elements a descarregar és massa gran, aplica un filtre a la capa per reduir-ne el número.',
  errorLayerExportFilteredSize:
    'El número d’elements a descarregar encara és massa gran, aplica un nou filtre a la capa per reduir-ne més el número.',
  errorAddFeature: "S'ha produit un error al crear l'element.",
  errorEditFeature: "S'ha produit un error al modificar l'element.",
  errorDeleteFeature: "S'ha produit un error a l'eliminar l'element.",
  searchError: "S'ha produit un error en la cerca",
  loadFileError: "S'ha produit un error al carregar el fitxer.",
  warnNoPk: "No s'ha trobat el punt quilomètric.",
  warnNoAddress: "No s'ha trobat cap adreça",
  warnNoTopo: "No s'ha trobat el topònim.",
  warnNoResults: "No s'han trobat resultats.",
  warnCharacters: 'La referència cadastral ha de tenir catorze catàcters',
  warnMun: "El camp 'Nom del municipi' és obligatori.",
  warmNoCadastre: 'La referència cadastral no existeix',
  warnField: 'El camp ',
  isMandatory: ' és obligatori',
  shouldNumber: ' ha de ser un número',
  coordinateFormat: 'Les coordenades no compleixen amb el format',
  backgroundScale: 'El fons seleccionat no disposa de cartografia a aquesta escala',
  infoTrue: "S'ha activat la informació de la capa.",
  infoFalse: "S'ha desactivat la informació de la capa.",
  downloadPrepare: "S'està preparant la descàrrega.",
  successSaveMap: "El mapa s'ha desat correctament.",
  successDeleteMap: "El mapa s'ha eliminat correctament",
  successCreation: "L'element s'ha creat correctament",
  successEdit: "L'element s'ha modificat correctament",
  successDelete: "L'element s'ha eliminat correctament",
  successDownloadFile: "L'arxiu s'ha descarregat correctament",
  infoFavs: 'Els preferits no es guardaran al mapa.',
  infoUserWms: "Les capes provinents d'un WMS extern no es guardaran al mapa.",
  layerNotLoaded1: 'La capa',
  layerNotLoaded2: "no s'ha pogut carregar",
  errorNoName: 'El mapa ha de tenir un nom definit.',
  errorParamsStyles: "El nombre d'estils a la URL no coincideix amb el nombre de capes.",
  errorParamsTransp: "El nombre d'opacitats a la URL no coincideix amb el nombre de capes.",

  //Estadístiques
  statsTotal: "Nombre d'elements",
  statsArit: 'Mitjana aritmètica',
  statsAritTitle: 'Suma de tots els elements dividit pel total',
  statsMedian: 'Mediana',
  statsMedianTitle: 'Valor al centre de la llista',
  statsMax: 'Màxim',
  statsMaxTitle: 'Valor més alt',
  statsMin: 'Mínim',
  statsMinTitle: 'Valor més baix',
  statsMode: 'Moda',
  statsModeTitle: 'Valor més freqüent',
  theLayer: 'La capa',
  noNumAtr: "no disposa d'atributs numérics.",
  selectAttr: 'Selecciona un atribut',

  //cataleg
  aria_catalegBtn: 'Catàleg',
  aria_tancarCataleg: 'tanca catàleg',
  aria_catalegTab1: 'Botó de catàleg', // tienen escrito "botó" porque el elemento es un h3 con onClick, también están aunque tengan texto porque si no no se sabe que es un botón si
  aria_catalegTab2: 'Botó de capes externes',
  aria_catalegTab3: "Botó de capes d'usuari",
  aria_catalegTab1Input: 'Cerca al catàleg',
  aria_catalegTab2Input: 'Cerca al catàleg de capes externes',
  aria_catalegTab3Input: 'Adreça del servei WMS',
  aria_catalegFileInput: 'Carrega fitxer local',
  aria_abreExpandir: 'Botó expandeix',
  aria_abreContreure: 'Botó contrau',
  aria_abreCheckbox: 'Selecciona',
  altTilesIcon: 'Icona cataleg',
  altSearchIcon: 'Icona buscar',
  altExpandAllIcon: 'Icona expandir tot',
  altShrinkAllIcon: 'Icona contraure tot',
  altShrinkIcon: 'Icona contraure',
  altExpandIcon: 'Icona expandir',
  altCheckboxIcon: 'Icona checkbox',
  obrirCataleg: 'Catàleg',
  buttonCarregaText: 'AFEGEIX CAPA',
  buttonTornarMapa: 'TORNA AL MAPA',
  shrinkAllIconText: 'Contrau tot',
  expandAllIconText: 'Expandeix tot',
  searchPlaceholder: 'Cerca al catàleg',
  catalogTitle: 'Catàleg',
  catalogHeaderTitle: 'Catàleg de capes',
  catalogHeaderDescription: 'Capes d’informació geogràfica generades per diferents departaments i organismes de la Generalitat de Catalunya.',
  externalTitle: 'Capes externes',
  externalHeaderTitle: 'Capes externes',
  externalHeaderDescription: 'Capes de fonts externes a la plataforma, procedents de connexions preestablertes a serveis WMS.',
  usuariTitle: "Capes d'usuari",
  usuariHeaderTitle: "Capes d'usuari",
  usuariHeaderDescription: 'Des d’aquest espai pots carregar fitxers locals o capes de serveis WMS.',
  usuariFitxerLocal: 'Carrega fitxer local',
  usuariFitxerLocalDescription: 'Els formats admesos són: GML, KML, JSON/GeoJSON o GPX.',
  usuariFitxerLocalDescription2: 'El fitxer es visualitzarà directament a la llegenda de forma temporal.',
  usuariServeis: 'Serveis WMS',
  addWMS: 'Connecta servei WMS',
  loadLocal: 'Carrega fitxer local',
  load: 'CARREGA',
  copyAddress: "Enganxa l'adreça del servei WMS en aquest camp",
  systemLayers: 'Capes al sistema',
  userLayers: "Capes de l'usuari",
  externalLayers: "Capes de l'usuari",
  searchExternalPlaceholder: 'Cerca al catàleg de capes externes',
  searchUserPlaceholder: 'Cerca a les capes carregades',
  error_carregarCapes: "No s'han pogut carregar les capes.",

  //cerca
  selectCapesText: 'Capes',
  selectElementsText: 'Localitzacions',
  selectSolrText: 'Elements',
  cercaAsistidaText: 'No has trobat el que buscaves? Cerca avançada',
  elementsTrobatsText: 'Elements trobats ',
  resultatsCapes: 'Resultats de la cerca de capes',
  resultatsElements: 'Resultats de la cerca de elements',
  resultatsLocalitzacions: 'Resultats de la cerca de localitzacions',
  filtreTipText: 'Ordenar per tipologia',
  filtreDataText: 'Ordenar per data',
  filtreDistText: 'Ordenar per distància',
  titolTaulaCapes: 'Resultats al catàleg de capes',
  titolTaulaElements: 'Localitzacions trobades',
  titolTaulaSolr: 'Elements de capes',
  descripcioTaulaCapes: 'En aquest espai trobaràs capes del catàleg relacionades amb la cerca textual que has fet.',
  descripcioTaulaElements: 'En aquest espai trobaràs topònims relacionats amb la cerca textual que has fet.',
  descripcioTaulaSolr: 'En aquest espai trobaràs elements del catàleg de capes relacionats amb la cerca textual que has fet. ',
  descripcioBoto: 'TORNA AL MAPA',
  tancarCerca: 'Tanca cerca',
  selectorFiltres: 'Sel·lector de filtres',
  filtres: 'Filtres: ',
  elementsCataleg: 'Elements de catàleg',
  toponims: 'Topònims',
  filtresCerca: 'Filtres de cerca..',
  noResults: "No s'ha trobat cap resultat per la cerca.",
  municipi: 'Municipi',
  capaAdreça: 'Capa: adreces',
  comarca: 'Comarca',
  capa: 'Capa',
  cadastrePH: 'Referència cadastral (14 primers caràcters)',
  filtrePH: 'Escriu per filtrar...',
  searchInfo: 'Informació sobre la cerca',
  nomMun: 'Nom del municipi (opcional)',

  //informacio de punt
  infoPunt: 'Informació del punt',
  infoPuntSelect: 'Informació del punt seleccionat',
  minimize: 'Minimitza',
  maximize: 'Maximitza',
  geographic: 'Geogràfiques (lat, long)',
  alçada: 'Altitud',
  carrer: 'Carrer',
  zoomPoint: 'Fes zoom al punt',
  zoomElement: "Fes zoom a l'element",
  exportGML: 'Descarrega en GML',
  exportCSV: 'Descarrega en CSV',
  exportSHP: 'Descarrega en ShapeFile',
  exportKML: 'Descarrega en KML',
  exportPDF: 'Descarrega en PDF',
  cercaRutes: 'Cercador de rutes',
  editFeature: "Edita l'element",
  deleteGeom: 'Elimina geometries',
  deleteFeature: "Elimina l'element",
  error_taula: "No s'ha pogut obtenir la taula de dades",
  urlWeb: 'Obre web',
  urlImg: 'Obre imatge',
  urlDoc: 'Obre document',
  addToFav: "Afegeix l'element a preferits",
  addElement: 'Afegeix element a la capa',
  deleteFeatureWarn: "Segur que vols eliminar l'element amb ID: ",
  deleteGeomWarn: 'Segur que vols eliminar la geometria? Aquesta acció no es podrà desfer.',
  noUndo: 'Aquesta acció no es podrà desfer.',
  favCoord: 'Afegeix coordenades del punt a preferits',
  dataPrec: 'Precisió de les dades',
  dataPrecText:
    'L’obtenció del carrer i el municipi a partir d’una coordenada (geocodificació inversa) és estimada. El geocodificador intenta trobar l’adreça més propera dins una distància màxima de 5 quilòmetres. Si no es troba cap adreça dins d’aquest radi no es mostra ni el carrer ni el municipi.',

  //fons cartografic
  aria_fonsBtn: 'obre selector de fons cartografics',
  aria_sliderMap: 'Transparència del mapa.',
  aria_laberThumb: 'Control de transparència del fons ',
  selectorFons: 'Selector de fons cartogràfic',
  moreOptions: 'Més opcions',
  moreInfo: 'Més informació',

  //ubicacio
  aria_ubicacioBtn: 'Ves a la meva ubicació',
  locationTitle: 'Ves a la meva ubicació',

  //navbar
  aria_menuPrincipalBtn: 'obre el menu principal',
  aria_accessibilitatBtn: "obre opcions d'accesibilitat",
  aria_compartirBtn: 'obre opcions de compartir',
  aria_bustiaContacteBtn: 'Ves a la bústia de contacte',
  aria_ajudaBtn: 'obre ajuda',
  aria_opcionsBtn: 'obre opcions',
  altIconSearch: 'Search Icon',
  altGencatIcon: 'Logo Gencat Blanc',
  altAccesibilityIcon: "Icona d'accesibility",
  altCommentIcon: 'Icona de comentaris',
  altQuestionIcon: "Icona d'ajuda",
  altMoreIcon: 'Icona de més opcions',
  altDeleteIcon: "Icona d'esborrar",
  altShareIcon: 'Share Icon',
  fontSizeAlt: 'Icona de tamany de lletra',
  contrastAlt: 'Icona de contrast',
  cercaPlaceholder: 'Cerca capes, elements de capes, localitzacions',
  cercaPhLayer: 'capes',
  cercaPhFeature: 'elements de capes',
  cercaPhPlace: 'localitzacions',
  menuPrincipal: 'Menu principal',
  cerca: 'Cerca',
  cercaAvançada: 'Cerca avançada',
  esborra: 'Esborra',
  esborrarCerca: 'Esborra cerca',
  esborrarCercaBtn: "botó d'esborrar cerca",
  accesibility: 'Accessibilitat',
  comments: 'Contacte',
  mida: 'Mida Lletra',
  contact: 'Contacte',
  help: 'Ajuda',
  moreOpts: 'Més opcions',
  contrast: 'Contrast',
  menu: 'Menu general',
  cercador: 'Cercador',
  cataleg: 'Catàleg de capes',
  fons: 'Canvi de fons cartogràfic',
  ubi: 'La meva ubicació',
  eines: 'Eines de dibuix i mesura',
  eines2: 'dibuix i cerca espaial',
  accessibilitat: 'Accessibilitat',
  share: 'Comparteix',
  compartir: 'Comparteix',
  print: 'Imprimeix el mapa',
  printText: 'Imprimeix',
  enviar: 'Envia missatge (bústia)',
  llegenda: 'Llegenda de capes',
  fletxa: 'fletxa',
  searchHelp: 'Què pots cercar i com?',
  compartirCopiar: 'L’enllaç de la visualització actual',
  compartirIncrustar: 'El codi per incrustar la visualització actual en un web',
  compartirImg: 'Descarrega la imatge',
  compartirPdf: 'Genera el PDF',
  compartirEmail: 'Correu electrònic',
  fullScreen: 'Activa/desactiva la pantalla completa',
  fullScreenRes: 'Pantalla completa',
  copyTitle: 'Copia al porta-retalls:',

  //sidebar
  aria_anteriorVersio: "Obre versió anterior de l'Hipermapa",
  aria_guiaUs: "obre la pantalla de guia d'ús",
  anteriorVersio: "Versió anterior de l'Hipermapa",
  enquesta: 'Enquesta',
  guiaUs: "Guia d'ús",
  faqs: 'Faqs',
  tutorial: 'Vídeos d’ajuda',
  bustiaContacte: 'Bústia de contacte',
  sobreGencat: 'Sobre Gencat',
  avisLegal: 'Avís legal',
  cookies: 'Política de galetes',
  sidebarText:
    'L’Hipermapa és el visor corporatiu de la Generalitat de Catalunya per publicar la informació georeferenciada generada des de diferents departaments o organismes del Govern català.',

  //upload files utils
  error_processFile: 'Error durant el processament de la informació del fitxer. Comprova que el fitxer sigui correcte.',
  error_loadFile: "Error en la càrrega d'arxiu.",
  error_incompatibleFormat: 'Els arxius compatibles són JSON, GEOJSON, GML, KML i GPX.',

  //redlining
  redliningHide: 'Mostra/amaga les eines',
  redliningPoint: 'Dibuixa un punt',
  measureDist: 'Activa/desactiva la mesura',
  measureLine: 'Dibuixa una línia',
  measureRad: 'Dibuixa un cercle',
  measureAr: 'Dibuixa una àrea',
  measureFree: 'Dibuixa una línia a mà alçada',
  writeMap: 'Escriu un text',
  downloadDraw: 'Descarrega els dibuixos',
  deleteMeasure: 'Elimina dibuixos',

  //modal inici
  aria_closeModalInici: 'Tanca wizard',
  aria_noMostrarModalInici: 'No tornar a mostrar',
  modalNews: 'Més novetats!',
  modalVersion:
    "Amb aquesta tercera actualització del visor, l'Hipermapa aconsegueix disposar de totes les eines i funcionalitats que tenia el seu predecessor.",
  noMostrar: 'No tornar a mostrar',
  button2: 'TANCA',
  modalTextMenu: 'o des del menú principal.',
  modalTextLink: "des d'aquí",
  modalText1: "Si vols col·laborar amb nosaltres per a millorar el visor, pots respondre a l'enquesta",
  modalEines: 'Més eines de dibuix',
  modalFav: 'Preferits',
  modalSave: 'Descarrega/carrega mapa',
  modalStats: 'Estadístiques de la capa',
  modalRaster: 'Possibilitat de consultar el valor del píxel d’una capa ràster',
  modalExt: 'Opció de modificar la simbologia d’una capa carregada des d’un fitxer local',
  modalTutorial: 'Nous vídeos d’ajuda',
  modalSubTitle: 'Ampliació de funcionalitats en eines ja existents:',
  modalSubTitle1: 'Eines incorporades:',
  modalFullScreen: 'Pantalla completa',

  //Modal Intranet

  modalITitle: 'Benvinguts a la nova interfície del visor!',
  modalISubTitle: "Estem redissenyant tot el Portal de mapes i en aquesta primera fase s'ha actualitzat el visor.",
  modalIText: "Us recomanen que consulteu l'apartat Ajuda",
  modalIText2: "on podeu trobar una guia d'ús i vídeos demostratius de les eines per facilitar-vos l'adaptació a aquest nou entorn.",

  //Galeria
  modalGaleria: 'Galeria d’imatges de l’element identificat',
  galeria: 'Galeria',
  forwardButton: 'Endavant',
  backButton: 'Enrere',

  //Modal error
  aria_closeModalError: "Tanca missatge d'error",
  alertaErrorTitle: "Missatge d'alerta al sistema",
  alertaErrorSubtitle: "S'ha produït un error.",

  //pantalla info cookies
  aria_closeInfo: "Tanca pantalla d'informació de politica de cookies",
  politicaGaletesTitle: 'Politica de cookies',

  //pantalla info accessibilitat
  aria_closeInfoAccess: "Tancar pantalla d'informació d'accessibilitat",
  aria_declaracioAccess: 'Declaració d’accessibilitat del web sig.gencat.cat',
  aria_situacio: 'Situació de compliment',
  aria_contNoAccess: 'Contingut no accessible',
  aria_linkDecreto: 'Real decreto 1112/2018',
  aria_preparacio: 'Preparació de la present declaració d’accessibilitat',
  aria_comunicacions: 'Comunicacions',
  aria_bustia: 'bústia de contacte',
  aria_solicituds: 'Sol·licituds d’informació accessible i queixes',
  aria_contingutAcces: 'Continguts accessibles al web',
  aria_solicitarInfo: 'Sol·licitar informació accessible o fer una queixa',
  aria_procediment: 'Procediment d’aplicació',
  aria_reclama: 'Reclamar una sol·licitud',
  aria_altres: 'Altres informacions',
  aria_compromisGene: "El compromís de la Generalitat per l'accessibilitat",
  accessibilitatTitle: 'Accessibilitat',
  accessibilitatDeclPar:
    'La Generalitat de Catalunya s’ha compromès a fer accessibles els seus webs de conformitat amb el Reial Decret 1112/2018, de 7 de setembre, sobre accessibilitat dels llocs web i aplicacions per a dispositius mòbils del sector públic (en endavant, Reial Decret 1112/2018, de 7 de setembre).',
  accessibilitatDeclPar2: 'Aquesta declaració d’accessibilitat s’aplica al web: sig.gencat.cat',
  accessibilitatSitPar:
    'Aquest lloc web és parcialment conforme amb el Reial Decret 1112/2018, de 7 de setembre, a causa de les excepcions i la manca de conformitat dels aspectes que s’indiquen a continuació.',
  accessibilitatContingutPar1:
    'Manca de conformitat amb el Reial Decret 1112/2018, de 7 de setembre: podrien existir diversos errors d’edició en alguna pàgina web, tant a continguts HTML com a documents finals, publicats amb data posterior al 20 de setembre de 2018.',
  accessibilitatContingutPar2: 'Càrrega desproporcionada: no aplica.',
  accessibilitatContingutPar3: 'El contingut no entra dins de l’àmbit de la legislació aplicable:',
  accessibilitatContingutLlista1:
    'El serveis de mapes i cartografia en línia queden exclosos de l’àmbit del Reial Decret 1112/2018, tal i com estableix en el seu article 3.4, lletra D.',
  accessibilitatContingutLlista2:
    'Pot haver continguts de tercers que no estiguin desenvolupats sota aquesta organització, ni sota el seu control, que tinguin enllaç des d’aquest lloc web.',
  accessibilitatContingutLlista3:
    'Podrien existir arxius ofimàtics en PDF o altres formats publicats abans del 20 de setembre de 2018 que no compleixin en la totalitat els requisits d’accessibilitat.',
  accessibilitatPreparacioPar1: 'La present declaració va ser preparada el 28 de novembre de 2022.',
  accessibilitatPreparacioPar2: 'El mètode utilitzat per preparar la declaració ha estat una autoavaluació portada a terme pel propi organisme. ',
  accessibilitatPreparacioPar3: 'Darrera revisió de la declaració: 28 de novembre de 2022.',
  accessibilitatComunicacionsPar1:
    'Es poden realitzar comunicacions sobre requisits d’accessibilitat (article 10.2.a del Reial Decret 1112/2018), a través de la següent',
  accessibilitatComunicacionsExemple: 'Per exemple:',
  accessibilitatComunicacionsLlista1: 'Informar sobre qualsevol possible incompliment per part d’aquest lloc web.',
  accessibilitatComunicacionsLlista2: 'Transmetre altres dificultats d’accés al contingut.',
  accessibilitatComunicacionsLlista3: 'Formular qualsevol altra consulta o suggeriment de millora relativa a l’accessibilitat del lloc web.',
  accessibilitatComunicacionsPar2:
    ' Les comunicacions seran rebudes i traslladades per la Direcció General de Serveis Digitals i Experiència Ciutadana, del Departament de la Presidència, com a Unitat Responsable d’Accessibilitat Web en l’àmbit autonòmic.',
  accesibilitatQueixesPar1: 'Per fer sol·licituds d’informació accessible i queixes (article 12 del Reial Decret 1112/2018) cal accedir al tràmit “',
  accesibilitatQueixesPar2: '” i seguir la modalitat “',
  accesibilitatQueixesPar3:
    'Qualsevol persona física o jurídica pot formular queixes relatives al compliment dels requisits del Reial Decret 1112/2018 i sol·licitar informació relativa a continguts que estiguin exclosos de l’àmbit d’aplicació d’aquesta normativa.',
  accesibilitatQueixesPar4:
    'Les sol·licituds i queixes es registren conforme als requisits establerts per la Llei 39/2015 d’1 d’octubre, del Procediment Administratiu Comú de les Administracions Públiques.',
  accesibilitatAplicacioPar1: 'El procediment d’aplicació recollit a l’article 13 del Reial Decret 1112/2018 es pot iniciar al tràmit “',
  accesibilitatAplicacioPar2: '” a través de la modalitat “',
  accesibilitatAplicacioPar3:
    'Si un cop realitzada una sol·licitud d’informació accessible o queixa, aquesta ha estat desestimada, no estàs d’acord amb la decisió adoptada o la resposta no compleix amb els requisits de l’article 12.5 del RD 1112/2018, pots iniciar una reclamació per:',
  accesibilitatAplicacioLlista1: 'Conèixer i oposar-te als motius de la desestimació',
  accesibilitatAplicacioLlista2: 'Instar a l’adopció de les mesures oportunes en cas de no estar d’acord amb la decisió adoptada',
  accesibilitatAplicacioLlista3: 'Exposar les raons per les quals consideres que la resposta no compleix amb els requisits exigits.',
  accesibilitatAplicacioPar4: 'També es pot iniciar una reclamació en cas que hagin transcorregut 20 dies hàbils sense haver obtingut cap resposta.',

  // Vector Tiles

  vectorMod: 'Arrossega per modificar',
  vectorInstr: 'Clica per afegir segment, doble clic per deixar de dibuixar',
  vectorInstrTouch: 'Arrossega per afegir segment, clica al vèrtex per deixar de dibuixar',
  vectorStart: 'Clica per començar a dibuixar',
  vectorStartTouch: 'Selecciona el punt inicial.',
  vectorWrite: 'Clica per començar a escriure',
  vectorDelete: 'Clica sobre un dibuix per eliminar-lo o fes un rectangle per eliminar-ne varis',
  vectorCircleTooltip: 'Clica i manté premut el botó per definir el radi',
  vectorFreeHandTooltip: 'Clica i manté premut el botó per dibuixar la línia',

  // Cerca avançada

  seleccionaCerca: 'Selecciona què vols cercar',
  dadesCataleg: 'Elements de capes del catàleg',
  toponim: 'Topònim',
  adreça: 'Adreça',
  puntKM: 'Punt quilomètric',
  coordsUTM: 'Coordenada en UTM (ETRS89)',
  selectedLayerPH: 'Nom de la capa (opcional)',
  selectedTipusViaPH: 'Tipus de via (opcional)',
  nomPoblacioPH: 'Nom de la població',
  coordsLatLon: 'Coordenada en latitud i longitud (graus decimals)',
  parcelaCadastral: 'Parcel·la cadastral',
  cercaPHCataleg: 'Element de la capa (Ex.: La conreria)',
  cercaPHToponim: 'Ex.: Barcelona',
  cercaPHAdress1: 'Nom de carrer (Ex. Meridiana)',
  cercaPHAdress2: 'Número de porta (opcional)',
  cercaPHAdress3: 'Població',
  cercaPHpk1: 'Codi de carretera (Ex.: A-14)',
  cercaPHpk2: 'Quilòmetre (Ex.: 10)',
  cercaCoordPH1: 'Coordenada X (Ex.: 438300)',
  cercaCoordPH2: 'Coordenada Y (Ex.: 4642360)',
  cercaLatLonPH1: 'Latitud (Ex.: 41.92894)',
  cercaLatLonPH2: 'Longitud (Ex.: 2.254689)',
  cercaAssistidaTitle: 'Cerca avançada',
  cercaAssistidaCercar: 'CERCA',
  cercaAssistidaCancelar: 'NETEJA',
  cercaAssistidaResultats: 'Resultats de la cerca',
  solROperatorsTitle:
    "Els següents modificadors els pots utilitzar per afegir precisió o flexibilitat a les cerques d'elements de capes, tant en aquesta cerca avançada com en la general",
  solRTitle1: 'Coincidència exacta',
  solRDesc1: 'Retorna els elements que continguin l’expressió exacte escrita entre cometes.',
  solRTitle2: 'Comodí de caràcter únic',
  solRDesc2: 'Retorna els elements amb un caràcter en el lloc del signe d’interrogació.',
  solRTitle3: 'Comodí de varis caràcters',
  solRDesc3: 'Retorna els elements amb zero o més caràcters en el lloc d’asterisc.',
  solRTitle4: 'Prohibeix el terme següent',
  solRDesc4: 'Retorna els elements que no contenen la cadena escrita després del signe exclamació.',
  solRTitle5: 'Requereix que hi hagi el terme següent',
  solRDesc5: 'Retorna els elements que contenen la cadena escrita després del símbol més.',

  //Filtre
  filterAddCond: 'AFEGEIX CONDICIÓ',
  filterAddSub: 'AFEGEIX SUBCONDICIÓ',
  filterAddSubReduced: 'SUBCONDICIÓ',
  filterAddCondReduced: 'CONDICIÓ',
  filterDelete: 'ELIMINA FILTRES',
  filterDeleteReduced: 'ELIMINA',
  filterApply: 'APLICA FILTRE',
  filterSelectField: 'Selecciona un camp',
  filterSelectoperator: 'Selecciona un operador',
  filterTitleCantApply: "Tots els camps han d'estar omplerts",
  filterTitle: 'Filtre de la capa',
  filterSpacial: 'Filtre espacial',
  filterAlphaNum: 'Filtre alfanumèric',
  filterLoading: 'Carregant...',
  filterExemple: 'Exemple: ',
  filterTitleCat: 'Filtra a tota catalunya',
  filterTitleRound: 'Filtra per radi',
  filterTitleRect: 'Filtra per rectangle',
  filterTitleArea: 'Filtra per àrea',
  filterTitleBbox: 'Filtra per vista de mapa',
  filterTitleSelect: 'Selecciona elements',
  filterIntroduce: 'Introdueix valor',
  operatorIgual: 'És igual a',
  operatorNoIgual: 'És diferent a',
  operatorBigger: 'És major que',
  operatorSmaller: 'És menor que',
  operatorBiggerEqual: 'És major o igual que',
  operatorSmallerEqual: 'És menor o igual que',
  operatorNull: 'És null',
  operatorNotNull: 'No és null',
  operatorStarts: 'Comença per',
  operatorEnds: 'Acaba per',
  operatorHas: 'Conté',
  operatorNotHas: 'No conté',

  //preferits
  favClear: 'Neteja els preferits',
  favEdit: 'Edita el nom',
  favApply: 'Aplica el nom',
  favZoom: 'Fes zoom al preferit',
  favDelete: 'Elimina el preferit',
  fav: 'Preferits',

  // Taula
  taulaNoResult: "No s'han trobat resultats pel filtre aplicat.",
  taulaOpenFilter: 'Obre el filtre a la llegenda',
  taulaCapa: 'Taula de la capa',
  taulaGoTo: 'Ves a',
  taulaAsc: 'Ordena de manera ascendent',
  taulaDesc: 'Ordena de manera descendent',
  taulaStnd: 'Ordena de manera estàndard',
  taulaPaginateOf: 'de',
  ascOrderTitle: 'Ordena de manera ascendent',
  stnOrderTitle: 'Ordena de manera estàndard',
  descOrderTitle: 'Ordena de manera descendent',

  // Modal correu exportacio
  modalExportTitle: 'Descàrrega de capa',
  modalToastErrorDescarrega: 'Hi ha hagut un error en la petició de descàrrega',
  modalToastErrorMida: "No es permet la descàrrega completa d'aquesta capa.",
  modalToastInfoSeleccionar: 'Seleccioneu el conjunt de registres a descarregar des de la taula de dades.',
  modalToastInfoEnviat: 'Petició enviada correctament',
  modalToastErrorPeticio: 'Hi ha hagut un error en la petició de descàrrega',
  modalLoggedUserEmail: "T'avisarem quan la descàrrega estigui disponible a l'adreça de sota. Pot modifcar-la a conveniencia.",
  modalNotLoggedUserEmail: 'Introdueix una adreça de correu electrònic on t’avisarem quan la descàrrega estigui disponible.',
  modalInputPlaceholderEmail: 'Escriu aquí el teu correu electrònic',
  modalTextExportData1: 'T’informem que les teves dades personals seran incloses en l’activitat de tractament:',
  modalTextExportData2: 'Informació bàsica sobre protecció de dades',
  modalTextExportData3: 'Identificació del tractament:',
  modalTextExportData4: 'Contactes',
  modalTextExportData5: 'Responsable del tractament:',
  modalTextExportData6: 'Secretaria General',
  modalTextExportData7: 'Finalitat:',
  modalTextExportData8:
    'gestionar les dades de les persones físiques i representants de persones jurídiques que es relacionen amb les diferents unitats del Departament, dins del seu àmbit competencial, amb motiu de la seva activitat professional.',
  modalTextExportData9: 'Drets de les persones interessades:',
  modalTextExportData10:
    'podeu sol·licitar l’accés, la rectificació o la supressió de les dades, i la limitació o l’oposició al tractament en aquest',
  modalTextExportData11: 'enllaç',
  modalTextExportData12: 'Informació addicional:',
  modalTextExportData13:
    'si voleu ampliar aquesta informació consulteu la fitxa descriptiva del tractament que es farà de les vostres dades personals en aquest',
  modalTextExportData14: 'He llegit la informació de protecció de dades i dono el meu consentiment per al tractament de les meves dades personals.',
  modalTextExportData15: 'ENVIAR'
};
